(() => {
  'use strict';

  /* PN_ADMIN_MENTOR_PAYMENTS_V1 */

  const dashboard =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );

  if (!dashboard) {
    return;
  }

  let financeRows = null;
  let loadingFinance = null;
  let timer = null;


  function esc(value) {
    return String(value ?? '')
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'",'&#039;');
  }


  function money(
    value,
    currency = 'INR'
  ) {

    return new Intl.NumberFormat(
      'en-IN',
      {
        style:'currency',
        currency:
          currency || 'INR',
        maximumFractionDigits:2
      }
    ).format(
      Number(value || 0)
    );

  }


  function dateText(value) {

    if (!value) {
      return '—';
    }

    const date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }

    return date.toLocaleString(
      undefined,
      {
        dateStyle:'medium',
        timeStyle:'short'
      }
    );

  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );

  }


  async function getFinanceRows(
    force = false
  ) {

    if (
      financeRows &&
      !force
    ) {
      return financeRows;
    }

    if (
      loadingFinance &&
      !force
    ) {
      return loadingFinance;
    }

    loadingFinance =
      rpc(
        'admin_list_mentor_finance_v2'
      )
        .then(result => {

          financeRows =
            Array.isArray(result)
              ? result
              : [];

          return financeRows;

        })
        .finally(() => {
          loadingFinance = null;
        });

    return loadingFinance;

  }


  function financeEmail(row) {

    return String(
      row?.mentor_email ||
      row?.email ||
      ''
    )
      .trim()
      .toLowerCase();

  }


  function financeName(row) {

    return String(
      row?.mentor_name ||
      row?.display_name ||
      row?.full_name ||
      ''
    )
      .trim()
      .toLowerCase();

  }


  function mentorId(row) {

    return String(
      row?.mentor_id ||
      row?.id ||
      ''
    );

  }


  function findFinanceForTableRow(
    row,
    finances
  ) {

    const email =
      String(
        row.querySelector(
          '.pnops__secondary'
        )?.textContent ||
        ''
      )
        .trim()
        .toLowerCase();

    const name =
      String(
        row.querySelector(
          '.pnops__primary'
        )?.textContent ||
        ''
      )
        .trim()
        .toLowerCase();

    return finances.find(
      finance =>
        (
          email &&
          financeEmail(finance) ===
          email
        )
        ||
        (
          !email &&
          name &&
          financeName(finance) ===
          name
        )
    );

  }


  function pill(status) {

    return `
      <span
        class="pn5-mentor-payments-pill"
        data-state="${esc(
          String(
            status || 'unknown'
          ).toLowerCase()
        )}"
      >
        ${esc(
          String(
            status || 'unknown'
          )
            .replaceAll('_',' ')
        )}
      </span>
    `;

  }


  function paymentMatchesMentor(
    payment,
    id,
    email
  ) {

    const ids = [
      payment?.mentor_id,
      ...(Array.isArray(
        payment?.mentor_ids
      )
        ? payment.mentor_ids
        : [])
    ]
      .filter(Boolean)
      .map(String);

    if (
      id &&
      ids.includes(
        String(id)
      )
    ) {
      return true;
    }

    const emails = [
      payment?.mentor_email,
      ...(Array.isArray(
        payment?.mentor_emails
      )
        ? payment.mentor_emails
        : [])
    ]
      .filter(Boolean)
      .map(
        value =>
          String(value)
            .toLowerCase()
      );

    return Boolean(
      email &&
      emails.includes(
        String(email)
          .toLowerCase()
      )
    );

  }


  function closeDrawer() {

    document
      .querySelector(
        '[data-pn5-mentor-payment-drawer]'
      )
      ?.remove();

  }


  async function openPayoutControls(
    id
  ) {

    const tab =
      document.querySelector(
        '[data-pn5-mentor-finance-tab]'
      );

    if (!tab) {
      return;
    }

    tab.click();

    for (
      let attempt = 0;
      attempt < 25;
      attempt += 1
    ) {

      await new Promise(
        resolve =>
          setTimeout(
            resolve,
            120
          )
      );

      const button =
        [
          ...document.querySelectorAll(
            '[data-pn5-mentor-detail]'
          )
        ]
          .find(
            node =>
              String(
                node.dataset
                  .pn5MentorDetail ||
                ''
              ) ===
              String(id)
          );

      if (button) {
        button.click();
        closeDrawer();
        return;
      }

    }

  }


  async function openDetail(
    finance
  ) {

    closeDrawer();

    const id =
      mentorId(finance);

    const email =
      financeEmail(finance);


    const drawer =
      document.createElement(
        'div'
      );

    drawer.className =
      'pn5-mentor-payments-drawer';

    drawer.setAttribute(
      'data-pn5-mentor-payment-drawer',
      ''
    );

    drawer.innerHTML = `
      <div
        class="pn5-mentor-payments-drawer__backdrop"
        data-pn5-payment-close
      ></div>

      <aside
        class="pn5-mentor-payments-drawer__panel"
      >

        <div class="pn5-mentor-payments-loading">
          Loading mentor details…
        </div>

      </aside>
    `;

    document.body
      .appendChild(drawer);


    drawer.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            '[data-pn5-payment-close]'
          )
        ) {

          closeDrawer();

        }

      }
    );


    const panel =
      drawer.querySelector(
        '.pn5-mentor-payments-drawer__panel'
      );


    try {

      const [
        detail,
        payments,
        payouts
      ] =
        await Promise.all([

          rpc(
            'admin_get_mentor_finance_detail_v2',
            {
              p_mentor_id:
                id
            }
          ),

          rpc(
            'admin_list_payment_operations_v2'
          ),

          rpc(
            'admin_list_mentor_payouts_v1'
          )

        ]);


      const mentorPayments =
        (
          Array.isArray(payments)
            ? payments
            : []
        )
          .filter(
            payment =>
              paymentMatchesMentor(
                payment,
                id,
                email
              )
          );


      const mentorPayouts =
        (
          Array.isArray(payouts)
            ? payouts
            : []
        )
          .filter(
            payout =>
              String(
                payout.mentor_id
              ) ===
              String(id)
          );


      const sessions =
        Array.isArray(
          detail?.sessions
        )
          ? detail.sessions
          : [];


      panel.innerHTML = `

        <div class="pn5-mentor-payments-head">

          <div>

            <span>
              MENTOR FINANCE
            </span>

            <h2>
              ${esc(
                detail?.mentor_name ||
                finance?.mentor_name ||
                finance?.display_name ||
                'PeerNest Mentor'
              )}
            </h2>

            <p>
              ${esc(
                detail?.mentor_email ||
                email ||
                ''
              )}
            </p>

          </div>

          <button
            type="button"
            data-pn5-payment-close
          >
            ×
          </button>

        </div>


        <div class="pn5-mentor-payment-stats">

          <article>
            <span>TOTAL SESSIONS</span>
            <strong>
              ${esc(
                finance.total_sessions ??
                sessions.length ??
                0
              )}
            </strong>
          </article>

          <article>
            <span>COMPLETED</span>
            <strong>
              ${esc(
                finance.completed_sessions ??
                0
              )}
            </strong>
          </article>

          <article>
            <span>UPCOMING</span>
            <strong>
              ${esc(
                finance.upcoming_sessions ??
                0
              )}
            </strong>
          </article>

          <article>
            <span>CANCELLED</span>
            <strong>
              ${esc(
                finance.cancelled_sessions ??
                0
              )}
            </strong>
          </article>

        </div>


        <div class="pn5-mentor-payment-stats pn5-mentor-payment-stats--money">

          <article>
            <span>TOTAL EARNINGS</span>
            <strong>
              ${money(
                finance.total_earnings,
                finance.currency
              )}
            </strong>
          </article>

          <article>
            <span>PAID</span>
            <strong>
              ${money(
                finance.paid,
                finance.currency
              )}
            </strong>
          </article>

          <article>
            <span>TO BE PAID</span>
            <strong>
              ${money(
                finance.to_be_paid,
                finance.currency
              )}
            </strong>
          </article>

        </div>


        <div class="pn5-mentor-payment-section">

          <div class="pn5-mentor-payment-section__head">

            <div>
              <span>INDIVIDUAL PAYMENTS</span>
              <h3>
                Every mentor payment
              </h3>
            </div>

            <button
              type="button"
              data-pn5-open-payout-controls
            >
              Payout controls
            </button>

          </div>


          ${
            mentorPayments.length
              ? `
                <div class="pn5-mentor-payment-table-wrap">

                  <table class="pn5-mentor-payment-table">

                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Student</th>
                        <th>Gross</th>
                        <th>Mentor 51%</th>
                        <th>PeerNest 49%</th>
                        <th>Payment</th>
                        <th>Earning</th>
                        <th>Razorpay ID</th>
                      </tr>
                    </thead>

                    <tbody>

                      ${mentorPayments
                        .map(
                          payment => `

                            <tr>

                              <td>
                                ${esc(
                                  dateText(
                                    payment.created_at
                                  )
                                )}
                              </td>

                              <td>

                                <strong>
                                  ${esc(
                                    payment.student_name ||
                                    'Student'
                                  )}
                                </strong>

                                <small>
                                  ${esc(
                                    payment.student_email ||
                                    ''
                                  )}
                                </small>

                              </td>

                              <td>
                                ${money(
                                  payment.amount ||
                                  payment.earning_gross ||
                                  0,
                                  payment.currency
                                )}
                              </td>

                              <td>
                                ${money(
                                  payment.earning_mentor_amount ||
                                  payment.mentor_amount ||
                                  0,
                                  payment.currency
                                )}
                              </td>

                              <td>
                                ${money(
                                  payment.earning_platform_amount ||
                                  payment.platform_amount ||
                                  0,
                                  payment.currency
                                )}
                              </td>

                              <td>
                                ${pill(
                                  payment.status
                                )}
                              </td>

                              <td>
                                ${pill(
                                  payment.earning_status ||
                                  'pending'
                                )}
                              </td>

                              <td>
                                <small>
                                  ${esc(
                                    payment.provider_payment_id ||
                                    payment.razorpay_payment_id ||
                                    '—'
                                  )}
                                </small>
                              </td>

                            </tr>
                          `
                        )
                        .join('')}

                    </tbody>

                  </table>

                </div>
              `
              : `
                <div class="pn5-mentor-payments-empty">
                  No individual payments yet.
                </div>
              `
          }

        </div>


        <div class="pn5-mentor-payment-section">

          <div class="pn5-mentor-payment-section__head">
            <div>
              <span>PAYOUT HISTORY</span>
              <h3>
                Mentor settlements
              </h3>
            </div>
          </div>

          ${
            mentorPayouts.length
              ? `
                <div class="pn5-mentor-payment-table-wrap">

                  <table class="pn5-mentor-payment-table">

                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Payout ID</th>
                        <th>UTR</th>
                      </tr>
                    </thead>

                    <tbody>

                      ${mentorPayouts
                        .map(
                          payout => `
                            <tr>

                              <td>
                                ${esc(
                                  dateText(
                                    payout.created_at
                                  )
                                )}
                              </td>

                              <td>
                                ${money(
                                  payout.amount,
                                  payout.currency
                                )}
                              </td>

                              <td>
                                ${pill(
                                  payout.status
                                )}
                              </td>

                              <td>
                                ${esc(
                                  payout.provider_payout_id ||
                                  '—'
                                )}
                              </td>

                              <td>
                                ${esc(
                                  payout.provider_utr ||
                                  '—'
                                )}
                              </td>

                            </tr>
                          `
                        )
                        .join('')}

                    </tbody>

                  </table>

                </div>
              `
              : `
                <div class="pn5-mentor-payments-empty">
                  No payouts yet.
                </div>
              `
          }

        </div>
      `;


      panel
        .querySelector(
          '[data-pn5-open-payout-controls]'
        )
        ?.addEventListener(
          'click',
          () =>
            openPayoutControls(
              id
            )
        );


    }
    catch (error) {

      panel.innerHTML = `

        <div class="pn5-mentor-payments-head">

          <h2>
            Could not load mentor payments
          </h2>

          <button
            type="button"
            data-pn5-payment-close
          >
            ×
          </button>

        </div>

        <div class="pn5-mentor-payments-empty">
          ${esc(
            error?.message ||
            'Unknown error'
          )}
        </div>
      `;

    }

  }


  async function enhanceTable() {

    /* PN5_MENTOR_PAYMENT_VIEW_GUARD */

    const mentorNav =
      dashboard.querySelector(
        '[data-pnadm-nav="mentors"]'
      );


    const hash =
      String(
        window.location.hash ||
        ''
      )
        .replace(
          '#',
          ''
        )
        .trim();


    const mentorsActive =
      hash === 'mentors'
      ||
      mentorNav
        ?.classList
        ?.contains(
          'is-active'
        );


    /*
      This enhancer belongs only to the mentor workspace.

      It previously continued reacting to dashboard DOM
      mutations while Payments / Colleges / other admin
      workspaces were open.
    */

    if (!mentorsActive) {
      return;
    }


    if (!window.PeerNestDB) {
      return;
    }

    const manager =
      dashboard.querySelector(
        '[data-pnadm-mentor-manager]'
      );

    const table =
      manager?.querySelector(
        'table'
      );

    if (!table) {
      return;
    }


    const finances =
      await getFinanceRows();


    const searchInput =
      manager.querySelector(
        '[data-pnadm-mentor-search]'
      );

    if (searchInput) {

      searchInput.placeholder =
        'Search name, email, college, program or mentor ID…';

    }


    const headerRow =
      table.querySelector(
        'thead tr'
      );


    if (
      headerRow &&
      !headerRow.querySelector(
        '[data-pn5-mentor-payment-head]'
      )
    ) {

      const th =
        document.createElement(
          'th'
        );

      th.textContent =
        'Payments';

      th.setAttribute(
        'data-pn5-mentor-payment-head',
        ''
      );

      headerRow.insertBefore(
        th,
        headerRow.lastElementChild
      );

    }


    table
      .querySelectorAll(
        'tbody tr'
      )
      .forEach(
        row => {

          if (
            row.querySelector(
              '[data-pn5-mentor-payment-cell]'
            )
          ) {
            return;
          }


          const finance =
            findFinanceForTableRow(
              row,
              finances
            );


          const cell =
            document.createElement(
              'td'
            );

          cell.setAttribute(
            'data-pn5-mentor-payment-cell',
            ''
          );


          if (!finance) {

            cell.innerHTML = `
              <span class="pn5-mentor-payment-total">
                ₹0
              </span>

              <small>
                No payment data
              </small>
            `;

          }
          else {

            cell.innerHTML = `

              <span class="pn5-mentor-payment-total">
                ${money(
                  finance.total_earnings,
                  finance.currency
                )}
              </span>

              <small>
                Paid
                ${money(
                  finance.paid,
                  finance.currency
                )}
                · Due
                ${money(
                  finance.to_be_paid,
                  finance.currency
                )}
              </small>

              <button
                type="button"
                data-pn5-view-mentor-payments
              >
                View details
              </button>
            `;


            cell
              .querySelector(
                '[data-pn5-view-mentor-payments]'
              )
              ?.addEventListener(
                'click',
                () =>
                  openDetail(
                    finance
                  )
              );

          }


          row.insertBefore(
            cell,
            row.lastElementChild
          );

        }
      );

  }


  function scheduleEnhance(
    force = false
  ) {

    clearTimeout(timer);

    timer =
      setTimeout(
        async () => {

          if (force) {
            await getFinanceRows(true);
          }

          enhanceTable();

        },
        180
      );

  }


  document.addEventListener(
    'click',
    event => {

      if (
        event.target.closest(
          '[data-pnadm-mentor-refresh]'
        )
      ) {

        financeRows = null;

        scheduleEnhance(true);

      }

    },
    true
  );


  const observer =
    new MutationObserver(
      () => {
        scheduleEnhance();
      }
    );


  observer.observe(
    dashboard,
    {
      childList:true,
      subtree:true
    }
  );


  document.addEventListener(
    'keydown',
    event => {

      if (
        event.key ===
        'Escape'
      ) {
        closeDrawer();
      }

    }
  );


  /* PN_ADMIN_MENTOR_PAYMENTS_PUBLIC_API_V1 */

  window.PeerNestAdminMentorPayments = {

    async openDetailById(
      id
    ) {

      const rows =
        await getFinanceRows();


      const finance =
        rows.find(
          row =>
            String(
              mentorId(row)
            ) ===
            String(id)
        );


      if (!finance) {

        throw new Error(
          'No finance record was found for this mentor.'
        );

      }


      return openDetail(
        finance
      );

    }

  };


  scheduleEnhance();

})();
